import './styles.scss';

const GeneralInfoBox = ({ children }) => <div className="box general-info-box">{children}</div>;

export default GeneralInfoBox;
